<template>
  <b-container fluid>
    <b-row>
      <b-col lg="12" md="12" sm="12">
        <iq-card class-name="iq-card-block iq-card-stretch" body-class="">
          <template v-slot:body>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12">
                <label class="typo__label">Dealer/s</label>
                <multiselect
                  v-model="dealers"
                  tag-placeholder="Add this as new tag"
                  placeholder="Search or add a dealer"
                  label="name"
                  track-by="id"
                  :options="getDealersWhichBelongsToUser"
                  :multiple="true"
                  :taggable="true"
                  @input="fnDelaersTagAdd()"
                >
                </multiselect>
              </div>
            </div>
          </template>
        </iq-card>
      </b-col>
      <b-col lg="12">
        <iq-card
          class-name="iq-card-block iq-card-stretch iq-card-height"
          body-class="row m-0 align-items-center pb-0"
        >
          <template v-slot:headerTitle>
            <h4 class="card-title">Total Settlements</h4>
          </template>
          <template v-slot:headerAction>
            <ul class="nav nav-pills">
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: periodMode == 'this-month' }"
                  @click="fnPeriod('this-month')"
                  >This month</a
                >
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: periodMode == 'last-month' }"
                  @click="fnPeriod('last-month')"
                  >Last month</a
                >
              </li>
              <li class="nav-item">
                <a
                  href="javascript:void(0);"
                  class="nav-link"
                  :class="{ active: periodMode == 'this-year' }"
                  @click="fnPeriod('this-year')"
                  >This year</a
                >
              </li>
            </ul>
          </template>
          <template v-slot:body>
            <b-col md="8">
              <div
                v-if="periodMode == 'this-month' && dataObj1 && dataObj1.labels"
              >
                <appBarChart :dataObj="dataObj1"></appBarChart>
              </div>
              <div
                v-if="periodMode == 'last-month' && dataObj2 && dataObj2.labels"
              >
                <appBarChart :dataObj="dataObj2"></appBarChart>
              </div>
              <div
                v-if="periodMode == 'this-year' && dataObj3 && dataObj3.labels"
              >
                <appBarChart :dataObj="dataObj3"></appBarChart>
              </div>
            </b-col>

            <b-col md="4">
              <div
                id="chart-data-block"
                v-if="periodMode == 'this-month' && dataObj1"
              >
                <h2 class="fs-1800">
                  <b>Summary Report</b> <br />
                  <span
                    ><p class="text-secondary fs-1000">
                      This Month
                      <span class="text-primary fs-800 fw-700"
                        >({{ currentMonthInText }})</span
                      >
                    </p></span
                  >
                </h2>

                <h4>
                  <b>Total Income</b> <br />
                  <span
                    ><p class="text-danger fs-1200">
                      ${{ dataObj1.dataTotInc | with-decimal }}
                    </p></span
                  >
                </h4>

                <h4>
                  <b>Total Settlements</b> <br />
                  <span
                    ><p class="text-secondary fs-1200">
                      {{ dataObj1.dataTotSettlement }}
                    </p></span
                  >
                </h4>
              </div>

              <div
                id="chart-data-block"
                v-if="periodMode == 'last-month' && dataObj2"
              >
                <h2 class="fs-1800">
                  <b>Summary Report</b> <br />
                  <span
                    ><p class="text-secondary fs-1000">
                      Last Month
                      <span class="text-primary fs-800 fw-700"
                        >({{ lastMonthInText }})</span
                      >
                    </p></span
                  >
                </h2>

                <h4>
                  <b>Total Income</b> <br />
                  <span
                    ><p class="text-danger fs-1200">
                      ${{ dataObj2.dataTotInc | with-decimal }}
                    </p></span
                  >
                </h4>
                <h4>
                  <b>Total Settlements</b> <br />
                  <span
                    ><p class="text-secondary fs-1200">
                      {{ dataObj2.dataTotSettlement }}
                    </p></span
                  >
                </h4>
              </div>

              <div
                id="chart-data-block"
                v-if="periodMode == 'this-year' && dataObj3"
              >
                <h2 class="fs-1800">
                  <b>Summary Report</b> <br />
                  <span
                    ><p class="text-secondary fs-1000">
                      This Year
                      <span class="text-primary fs-800 fw-700"
                        >({{ currentYearInText }})</span
                      >
                    </p></span
                  >
                </h2>

                <h4>
                  <b>Total Income</b> <br />
                  <span
                    ><p class="text-danger fs-1200">
                      ${{ dataObj3.dataTotInc | with-decimal }}
                    </p></span
                  >
                </h4>
                <h4>
                  <b>Total Settlements</b> <br />
                  <span
                    ><p class="text-secondary fs-1200">
                      {{ dataObj3.dataTotSettlement }}
                    </p></span
                  >
                </h4>
              </div>
            </b-col>
          </template>
        </iq-card>
      </b-col>

      <!-- Video guide -->
      <b-col lg="12">
        <iq-card class-name="iq-card-block iq-card-stretch iq-card-height">
          <template v-slot:headerTitle>
            <h4 class="card-title">Video guide</h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col lg="2" v-for="(video, index) in videos" :key="index">
                <appVideoPlaceHolder
                  :title="video.title"
                  :coverImgUrl="video.imageUrl"
                  :videoUrl="video.url"
                ></appVideoPlaceHolder>
              </b-col>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { findash } from '../../config/pluginInit'
import moment from 'moment'
import bgImage from '../../assets/images/page-img/45.png'
import appVideoPlaceHolder from '../../components/wd/VideoPlaceHolder.vue'
import { mapGetters, mapActions } from 'vuex'
import appChartBox from '../../components/charts/ChartBox.vue'
import appBarChart from '../../components/charts/BarChart.vue'
import * as authService from '../../services/auth.service'

export default {
  name: 'DashboardDealer',
  components: {
    appVideoPlaceHolder,
    appChartBox,
    appBarChart
  },
  mounted() {
    findash.index()
    setTimeout(() => this.fnPeriod(this.periodMode), 3000)
  },
  data() {
    return {
      videos: [
        {
          title: 'What is a Novated Lease',
          imageUrl: require('../../assets/images/video-tutorials/f1.jpg'),
          url: '/videos/music_novated_lease_explained.mp4'
        },
        {
          title: 'Save Tax & GST',
          imageUrl: require('../../assets/images/video-tutorials/f2.jpg'),
          url: '/videos/novated_lease_savings.mp4'
        },
        {
          title: 'SA Government Employees',
          imageUrl: require('../../assets/images/video-tutorials/f3.jpg'),
          url: '/videos/sa_government_employees.mp4'
        },
        {
          title: 'Options at the end of the lease',
          imageUrl: require('../../assets/images/video-tutorials/f4.jpg'),
          url: '/videos/options_at_the_end_of_the_lease.mp4'
        },
        {
          title: 'Which employees can we assist',
          imageUrl: require('../../assets/images/video-tutorials/f5.jpg'),
          url: '/videos/which_employees_can_we_asist_with_novated_leasing.mp4'
        }
        // {
        //   title: 'Move Your Body',
        //   imageUrl: require('../../assets/images/video-tutorials/f5.jpg'),
        //   url: 'https://www.youtube.com/watch?v=fNfe6WdXRdA'
        // },
        // {
        //   title: 'Try New Things',
        //   imageUrl: require('../../assets/images/video-tutorials/f6.jpg'),
        //   url: 'https://www.youtube.com/watch?v=s4ObxcdXoFE'
        // }
      ],
      dealers: [],
      getDealersWhichBelongsToUser: [],

      arrDataQuotesId: [],
      totalQuotes: 0,
      totalApprovals: 0,
      totalSettlements: 0,
      totalIncome: 0,

      dataQuotes: [],
      dataApprovals: [],
      dataSettlements: [],
      dataIncome: [],
      labelMonths: [],
      periodMode: 'this-month',
      dataObj1: '',
      dataObj2: '',
      dataObj3: '',
      bgImageURL: bgImage,
      userObj: {},

      numOfNewDeal: 0, // Number of new Deals
      numOfNewHelpRequest: 0, // Number of new Help Request

      currentMonthInText: '',
      lastMonthInText: '',
      currentYearInText: ''
    }
  },
  computed: {
    ...mapGetters([
      //need this
      'getUserById',
      'gettDDealerThisMonthData',
      'gettDDealerLastMonthData',
      'gettDDealerLastYearData'
    ])
  },
  methods: {
    ...mapActions([
      //need this
      'fetchUserById',
      'fetchDDealerThisMonthData',
      'fetchDDealerLastMonthData',
      'fetchDDealerLastYearData'
    ]),

    // This month data
    getThisMonthData() {
      let obj = {}
      let lenDays = moment().daysInMonth()
      let arrthisMonthQuote = []
      let arrthisMonthsettlement = []
      let arrLabel = []
      let arr = this.gettDDealerThisMonthData.data_new_quote
      let arrS = this.gettDDealerThisMonthData.data_settlement_quote
      let totQuote = 0
      let totSettlement = 0
      let totInc = 0

      for (var i = 0, len = lenDays; i < len; i++) {
        arrthisMonthQuote[i] = 0
        arrthisMonthsettlement[i] = 0
        arrLabel[i] = i + 1

        // New Quote for the month
        for (var j = 0, lenj = arr.length; j < lenj; j++) {
          let q = 0
          if (
            moment(arr[j].created_at).format('DD') == i + 0 &&
            this.arrDataQuotesId.length == 0
          ) {
            q = arrthisMonthQuote[i - 1]
            arrthisMonthQuote[i - 1] = Number(q) + 1
            totQuote = totQuote + 1
          } else if (
            moment(arr[j].created_at).format('DD') == i + 0 &&
            this.arrDataQuotesId.includes(arr[j].dealerId.toString())
          ) {
            q = arrthisMonthQuote[i - 1]
            arrthisMonthQuote[i - 1] = Number(q) + 1
            totQuote = totQuote + 1
          }
        }

        // Settlement Quote for the month
        for (var k = 0, lenk = arrS.length; k < lenk; k++) {
          let s2 = 0
          if (
            moment(arrS[k].settlementDate).format('DD') == i + 0 &&
            this.arrDataQuotesId.length == 0
          ) {
            s2 = arrthisMonthsettlement[i - 1]
            arrthisMonthsettlement[i - 1] = Number(s2) + 1
            totSettlement = totSettlement + 1

            totInc =
              Number(totInc) +
              Number(arrS[k].totalDriveAwayCost) *
                Number(arrS[k].dealerBrokerage)
          } else if (
            moment(arrS[k].settlementDate).format('DD') == i + 0 &&
            this.arrDataQuotesId.includes(arrS[k].dealerId.toString())
          ) {
            s2 = arrthisMonthsettlement[i - 1]
            arrthisMonthsettlement[i - 1] = Number(s2) + 1
            totSettlement = totSettlement + 1

            totInc =
              Number(totInc) +
              Number(arrS[k].totalDriveAwayCost) *
                Number(arrS[k].dealerBrokerage)
          }
        }
      }

      obj = {
        dataQuotes: arrthisMonthQuote,
        dataSettlements: arrthisMonthsettlement,
        dataLabels: arrLabel,
        dataTotQuotes: totQuote,
        dataTotSettlement: totSettlement,
        dataTotInc: totInc
      }
      return obj
    },

    // Last month data
    getLastMonthData() {
      let obj = {}
      let lenDays = moment().add(-1, 'month').daysInMonth()
      let arrLastMonthQuote = []
      let arrLastMonthsettlement = []
      let arrLabel = []
      let arr = this.gettDDealerLastMonthData.data_new_quote
      let arrS = this.gettDDealerLastMonthData.data_settlement_quote
      let totQuote = 0
      let totSettlement = 0
      let totInc = 0

      for (var i = 0, len = lenDays; i < len; i++) {
        arrLastMonthQuote[i] = 0
        arrLastMonthsettlement[i] = 0
        arrLabel[i] = i + 1

        // Last month quotes
        for (var j = 0, lenj = arr.length; j < lenj; j++) {
          let q = 0

          if (
            moment(arr[j].created_at).format('DD') == i + 0 &&
            this.arrDataQuotesId.length == 0
          ) {
            q = arrLastMonthQuote[i - 1]
            arrLastMonthQuote[i - 1] = Number(q) + 1
            totQuote = totQuote + 1
          } else if (
            moment(arr[j].created_at).format('DD') == i + 0 &&
            this.arrDataQuotesId.includes(arr[j].dealerId)
          ) {
            q = arrLastMonthQuote[i - 1]
            arrLastMonthQuote[i - 1] = Number(q) + 1
            totQuote = totQuote + 1
          }
        }

        // Last month Settlement
        for (var k = 0, lenk = arrS.length; k < lenk; k++) {
          let s = 0

          if (
            moment(arrS[k].settlementDate).format('DD') == i + 0 &&
            this.arrDataQuotesId.length == 0
          ) {
            s = arrLastMonthsettlement[i - 1]
            arrLastMonthsettlement[i - 1] = Number(s) + 1
            totSettlement = totSettlement + 1

            totInc =
              Number(totInc) +
              Number(arrS[k].totalDriveAwayCost) *
                Number(arrS[k].dealerBrokerage)
          } else if (
            moment(arrS[k].settlementDate).format('DD') == i + 0 &&
            this.arrDataQuotesId.includes(arrS[k].dealerId.toString())
          ) {
            s = arrLastMonthsettlement[i - 1]
            arrLastMonthsettlement[i - 1] = Number(s) + 1
            totSettlement = totSettlement + 1

            totInc =
              Number(totInc) +
              Number(arrS[k].totalDriveAwayCost) *
                Number(arrS[k].dealerBrokerage)
          }
        }
      }

      obj = {
        dataQuotes: arrLastMonthQuote,
        dataSettlements: arrLastMonthsettlement,
        dataLabels: arrLabel,
        dataTotQuotes: totQuote,
        dataTotSettlement: totSettlement,
        dataTotInc: totInc
      }
      return obj
    },

    // Get last year data
    getDashbordInformation() {
      let obj = {}
      const currentDate = moment().format('YYYY-MM-DD')
      let quoteMonth01 = 0
      let quoteMonth02 = 0
      let quoteMonth03 = 0
      let quoteMonth04 = 0
      let quoteMonth05 = 0
      let quoteMonth06 = 0
      let quoteMonth07 = 0
      let quoteMonth08 = 0
      let quoteMonth09 = 0
      let quoteMonth10 = 0
      let quoteMonth11 = 0
      let quoteMonth12 = 0

      let settlementsMonth01 = 0
      let settlementsMonth02 = 0
      let settlementsMonth03 = 0
      let settlementsMonth04 = 0
      let settlementsMonth05 = 0
      let settlementsMonth06 = 0
      let settlementsMonth07 = 0
      let settlementsMonth08 = 0
      let settlementsMonth09 = 0
      let settlementsMonth10 = 0
      let settlementsMonth11 = 0
      let settlementsMonth12 = 0

      let incomeMonth01 = 0
      let incomeMonth02 = 0
      let incomeMonth03 = 0
      let incomeMonth04 = 0
      let incomeMonth05 = 0
      let incomeMonth06 = 0
      let incomeMonth07 = 0
      let incomeMonth08 = 0
      let incomeMonth09 = 0
      let incomeMonth10 = 0
      let incomeMonth11 = 0
      let incomeMonth12 = 0

      let monthText01 = ''
      let monthText02 = ''
      let monthText03 = ''
      let monthText04 = ''
      let monthText05 = ''
      let monthText06 = ''
      let monthText07 = ''
      let monthText08 = ''
      let monthText09 = ''
      let monthText10 = ''
      let monthText11 = ''
      let monthText12 = ''
      let dataGetLastYearDetails = []
      let quoteCount = 0
      let totalQuotes = 0
      let settCount = 0
      let totalSettlements = 0
      let totInc = 0

      const arr = this.gettDDealerLastYearData.data_new_quote
      const arrS = this.gettDDealerLastYearData.data_settlement_quote
      let arrDataQuotesId = this.arrDataQuotesId

      for (var i = 0, len = arr.length; i < len; i++) {
        //All the quotes
        if (arrDataQuotesId.length == 0) {
          // Total whole quotes
          totalQuotes = arr.length

          if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).format('YYYY-MM')
          ) {
            quoteMonth01 = Number(quoteMonth01) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-1, 'month').format('YYYY-MM')
          ) {
            quoteMonth02 = Number(quoteMonth02) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-2, 'month').format('YYYY-MM')
          ) {
            quoteMonth03 = Number(quoteMonth03) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-3, 'month').format('YYYY-MM')
          ) {
            quoteMonth04 = Number(quoteMonth04) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-4, 'month').format('YYYY-MM')
          ) {
            quoteMonth05 = Number(quoteMonth05) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-5, 'month').format('YYYY-MM')
          ) {
            quoteMonth06 = Number(quoteMonth06) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-6, 'month').format('YYYY-MM')
          ) {
            quoteMonth07 = Number(quoteMonth07) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-7, 'month').format('YYYY-MM')
          ) {
            quoteMonth08 = Number(quoteMonth08) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-8, 'month').format('YYYY-MM')
          ) {
            quoteMonth09 = Number(quoteMonth09) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-9, 'month').format('YYYY-MM')
          ) {
            quoteMonth10 = Number(quoteMonth10) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-10, 'month').format('YYYY-MM')
          ) {
            quoteMonth11 = Number(quoteMonth11) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-11, 'month').format('YYYY-MM')
          ) {
            quoteMonth12 = Number(quoteMonth12) + 1
          }
        } else if (arrDataQuotesId.includes(arr[i].dealerId.toString())) {
          // Total whole quotes according to dealer/s
          quoteCount = Number(quoteCount) + 1
          totalQuotes = quoteCount

          if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).format('YYYY-MM')
          ) {
            quoteMonth01 = Number(quoteMonth01) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-1, 'month').format('YYYY-MM')
          ) {
            quoteMonth02 = Number(quoteMonth02) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-2, 'month').format('YYYY-MM')
          ) {
            quoteMonth03 = Number(quoteMonth03) + 1
          } else if (
            moment(arr[i].createdat).format('YYYY-MM') ==
            moment(currentDate).add(-3, 'month').format('YYYY-MM')
          ) {
            quoteMonth04 = Number(quoteMonth04) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-4, 'month').format('YYYY-MM')
          ) {
            quoteMonth05 = Number(quoteMonth05) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-5, 'month').format('YYYY-MM')
          ) {
            quoteMonth06 = Number(quoteMonth06) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-6, 'month').format('YYYY-MM')
          ) {
            quoteMonth07 = Number(quoteMonth07) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-7, 'month').format('YYYY-MM')
          ) {
            quoteMonth08 = Number(quoteMonth08) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-8, 'month').format('YYYY-MM')
          ) {
            quoteMonth09 = Number(quoteMonth09) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-9, 'month').format('YYYY-MM')
          ) {
            quoteMonth10 = Number(quoteMonth10) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-10, 'month').format('YYYY-MM')
          ) {
            quoteMonth11 = Number(quoteMonth11) + 1
          } else if (
            moment(arr[i].created_at).format('YYYY-MM') ==
            moment(currentDate).add(-11, 'month').format('YYYY-MM')
          ) {
            quoteMonth12 = Number(quoteMonth12) + 1
          }
        }
      }

      for (var i = 0, len = arrS.length; i < len; i++) {
        // Settlements
        if (arrDataQuotesId.length == 0) {
          //Total whole Settlments quotes
          settCount = Number(settCount) + 1
          totalSettlements = settCount

          if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(0, 'month').format('YYYY-MM')
          ) {
            settlementsMonth01 = Number(settlementsMonth01) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-1, 'month').format('YYYY-MM')
          ) {
            settlementsMonth02 = Number(settlementsMonth02) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-2, 'month').format('YYYY-MM')
          ) {
            settlementsMonth03 = Number(settlementsMonth03) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-3, 'month').format('YYYY-MM')
          ) {
            settlementsMonth04 = Number(settlementsMonth04) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-4, 'month').format('YYYY-MM')
          ) {
            settlementsMonth05 = Number(settlementsMonth05) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-5, 'month').format('YYYY-MM')
          ) {
            settlementsMonth06 = Number(settlementsMonth06) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-6, 'month').format('YYYY-MM')
          ) {
            settlementsMonth07 = Number(settlementsMonth07) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-7, 'month').format('YYYY-MM')
          ) {
            settlementsMonth08 = Number(settlementsMonth08) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-8, 'month').format('YYYY-MM')
          ) {
            settlementsMonth09 = Number(settlementsMonth09) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-9, 'month').format('YYYY-MM')
          ) {
            settlementsMonth10 = Number(settlementsMonth10) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-10, 'month').format('YYYY-MM')
          ) {
            settlementsMonth11 = Number(settlementsMonth11) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-11, 'month').format('YYYY-MM')
          ) {
            settlementsMonth12 = Number(settlementsMonth12) + 1
          }
        } else if (arrDataQuotesId.includes(arrS[i].dealerId.toString())) {
          //Total whole Settlments quotes
          settCount = Number(settCount) + 1
          totalSettlements = settCount

          if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).format('YYYY-MM')
          ) {
            settlementsMonth01 = Number(settlementsMonth01) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-1, 'month').format('YYYY-MM')
          ) {
            settlementsMonth02 = Number(settlementsMonth02) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-2, 'month').format('YYYY-MM')
          ) {
            settlementsMonth03 = Number(settlementsMonth03) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-3, 'month').format('YYYY-MM')
          ) {
            settlementsMonth04 = Number(settlementsMonth04) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-4, 'month').format('YYYY-MM')
          ) {
            settlementsMonth05 = Number(settlementsMonth05) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-5, 'month').format('YYYY-MM')
          ) {
            settlementsMonth06 = Number(settlementsMonth06) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-6, 'month').format('YYYY-MM')
          ) {
            settlementsMonth07 = Number(settlementsMonth07) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-7, 'month').format('YYYY-MM')
          ) {
            settlementsMonth08 = Number(settlementsMonth08) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-8, 'month').format('YYYY-MM')
          ) {
            settlementsMonth09 = Number(settlementsMonth09) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-9, 'month').format('YYYY-MM')
          ) {
            settlementsMonth10 = Number(settlementsMonth10) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-10, 'month').format('YYYY-MM')
          ) {
            settlementsMonth11 = Number(settlementsMonth11) + 1
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-11, 'month').format('YYYY-MM')
          ) {
            settlementsMonth12 = Number(settlementsMonth12) + 1
          }
        }

        if (arrDataQuotesId.length == 0) {
          //Total whole Settlments quotes
          totInc =
            Number(totInc) +
            Number(arrS[i].totalDriveAwayCost) * Number(arrS[i].dealerBrokerage)

          if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).format('YYYY-MM')
          ) {
            incomeMonth01 =
              Number(incomeMonth01) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-1, 'month').format('YYYY-MM')
          ) {
            incomeMonth02 =
              Number(incomeMonth02) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-2, 'month').format('YYYY-MM')
          ) {
            incomeMonth03 =
              Number(incomeMonth03) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-3, 'month').format('YYYY-MM')
          ) {
            incomeMonth04 =
              Number(incomeMonth04) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-4, 'month').format('YYYY-MM')
          ) {
            incomeMonth05 =
              Number(incomeMonth05) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-5, 'month').format('YYYY-MM')
          ) {
            incomeMonth06 =
              Number(incomeMonth06) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-6, 'month').format('YYYY-MM')
          ) {
            incomeMonth07 =
              Number(incomeMonth07) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-7, 'month').format('YYYY-MM')
          ) {
            incomeMonth08 =
              Number(incomeMonth08) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-8, 'month').format('YYYY-MM')
          ) {
            incomeMonth09 =
              Number(incomeMonth09) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-9, 'month').format('YYYY-MM')
          ) {
            incomeMonth10 =
              Number(incomeMonth10) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-10, 'month').format('YYYY-MM')
          ) {
            incomeMonth11 =
              Number(incomeMonth11) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-11, 'month').format('YYYY-MM')
          ) {
            incomeMonth12 =
              Number(incomeMonth12) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          }
        } else if (arrDataQuotesId.includes(arrS[i].dealerId.toString())) {
          //Total whole Settlments quotes
          totInc =
            Number(totInc) +
            Number(arrS[i].totalDriveAwayCost) * Number(arrS[i].dealerBrokerage)

          if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).format('YYYY-MM')
          ) {
            incomeMonth01 =
              Number(incomeMonth01) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-1, 'month').format('YYYY-MM')
          ) {
            incomeMonth02 =
              Number(incomeMonth02) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-2, 'month').format('YYYY-MM')
          ) {
            incomeMonth03 =
              Number(incomeMonth03) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-3, 'month').format('YYYY-MM')
          ) {
            incomeMonth04 =
              Number(incomeMonth04) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-4, 'month').format('YYYY-MM')
          ) {
            incomeMonth05 =
              Number(incomeMonth05) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-5, 'month').format('YYYY-MM')
          ) {
            incomeMonth06 =
              Number(incomeMonth06) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-6, 'month').format('YYYY-MM')
          ) {
            incomeMonth07 =
              Number(incomeMonth07) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-7, 'month').format('YYYY-MM')
          ) {
            incomeMonth08 =
              Number(incomeMonth08) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-8, 'month').format('YYYY-MM')
          ) {
            incomeMonth09 =
              Number(incomeMonth09) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-9, 'month').format('YYYY-MM')
          ) {
            incomeMonth10 =
              Number(incomeMonth10) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-10, 'month').format('YYYY-MM')
          ) {
            incomeMonth11 =
              Number(incomeMonth11) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          } else if (
            moment(arrS[i].settlementDate).format('YYYY-MM') ==
            moment(currentDate).add(-11, 'month').format('YYYY-MM')
          ) {
            incomeMonth12 =
              Number(incomeMonth12) +
              Number(arrS[i].totalDriveAwayCost) *
                Number(arrS[i].dealerBrokerage)
          }
        }
      }

      monthText01 = moment(currentDate).add(0, 'month').format('MMM')
      monthText02 = moment(currentDate).add(-1, 'month').format('MMM')
      monthText03 = moment(currentDate).add(-2, 'month').format('MMM')
      monthText04 = moment(currentDate).add(-3, 'month').format('MMM')
      monthText05 = moment(currentDate).add(-4, 'month').format('MMM')
      monthText06 = moment(currentDate).add(-5, 'month').format('MMM')
      monthText07 = moment(currentDate).add(-6, 'month').format('MMM')
      monthText08 = moment(currentDate).add(-7, 'month').format('MMM')
      monthText09 = moment(currentDate).add(-8, 'month').format('MMM')
      monthText10 = moment(currentDate).add(-9, 'month').format('MMM')
      monthText11 = moment(currentDate).add(-10, 'month').format('MMM')
      monthText12 = moment(currentDate).add(-11, 'month').format('MMM')

      dataGetLastYearDetails = [
        {
          dataQuotes: quoteMonth01,
          dataSettlements: settlementsMonth01,
          dataIncome: incomeMonth01,
          month: monthText01
        },
        {
          dataQuotes: quoteMonth02,
          dataSettlements: settlementsMonth02,
          dataIncome: incomeMonth02,
          month: monthText02
        },
        {
          dataQuotes: quoteMonth03,
          dataSettlements: settlementsMonth03,
          dataIncome: incomeMonth03,
          month: monthText03
        },
        {
          dataQuotes: quoteMonth04,
          dataSettlements: settlementsMonth04,
          dataIncome: incomeMonth04,
          month: monthText04
        },
        {
          dataQuotes: quoteMonth05,
          dataSettlements: settlementsMonth05,
          dataIncome: incomeMonth05,
          month: monthText05
        },
        {
          dataQuotes: quoteMonth06,
          dataSettlements: settlementsMonth06,
          dataIncome: incomeMonth06,
          month: monthText06
        },
        {
          dataQuotes: quoteMonth07,
          dataSettlements: settlementsMonth07,
          dataIncome: incomeMonth07,
          month: monthText07
        },
        {
          dataQuotes: quoteMonth08,
          dataSettlements: settlementsMonth08,
          dataIncome: incomeMonth08,
          month: monthText08
        },
        {
          dataQuotes: quoteMonth09,
          dataSettlements: settlementsMonth09,
          dataIncome: incomeMonth09,
          month: monthText09
        },
        {
          dataQuotes: quoteMonth10,
          dataSettlements: settlementsMonth10,
          dataIncome: incomeMonth10,
          month: monthText10
        },
        {
          dataQuotes: quoteMonth11,
          dataSettlements: settlementsMonth11,
          dataIncome: incomeMonth11,
          month: monthText11
        },
        {
          dataQuotes: quoteMonth12,
          dataSettlements: settlementsMonth12,
          dataIncome: incomeMonth12,
          month: monthText12
        }
      ]

      this.dataQuotes = dataGetLastYearDetails.map((obj) => obj.dataQuotes)
      this.dataSettlements = dataGetLastYearDetails.map(
        (obj) => obj.dataSettlements
      )
      this.dataIncome = dataGetLastYearDetails.map((obj) => obj.dataIncome)
      this.labelMonths = dataGetLastYearDetails.map((obj) => obj.month)
      this.totalQuotes = totalQuotes
      this.totalSettlements = totalSettlements
      this.totalIncome = totInc

      obj = {
        dataQuotes: this.dataQuotes,
        dataSettlements: this.dataSettlements,
        dataLabels: this.labelMonths,
        dataTotQuotes: this.totalQuotes,
        dataTotSettlement: this.totalSettlements,
        dataTotInc: this.totalIncome
      }
      return obj
    },

    getDashbordOtherInformation() {
      this.numOfNewDeal = 0
      this.numOfNewHelpRequest = 0
      const arr = this.gettDDealerLastYearData

      for (var i = 0, len = arr.length; i < len; i++) {
        //Get number of New Deals

        this.numOfNewDeal = Number(this.numOfNewDeal) + 1
      }
    },

    fnPeriodThisMonth() {
      // This month data
      let thisMonthData = this.getThisMonthData()

      let obj = {
        series: [
          {
            data: thisMonthData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: thisMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: thisMonthData.dataTotSettlement,
        dataTotInc: thisMonthData.dataTotInc
      }
      this.dataObj1 = obj
    },
    fnPeriodLastMonth() {
      // Last month data
      let lastMonthData = this.getLastMonthData()

      let obj = {
        series: [
          {
            data: lastMonthData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: lastMonthData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: lastMonthData.dataTotSettlement,
        dataTotInc: lastMonthData.dataTotInc
      }
      this.dataObj2 = obj
    },
    fnPeriodLastYear() {
      // Last year data
      let thisYearData = this.getDashbordInformation()
      let obj = {
        series: [
          {
            data: thisYearData.dataSettlements,
            name: ['Settlements']
          }
        ],
        labels: thisYearData.dataLabels,
        colors: ['#1e3d73'],
        dataTotSettlement: thisYearData.dataTotSettlement,
        dataTotInc: thisYearData.dataTotInc
      }
      this.dataObj3 = obj
    },

    fnPeriod(periodMode) {
      this.periodMode = periodMode

      if (this.periodMode == 'this-month') {
        this.fnPeriodThisMonth()
      } else if (this.periodMode == 'last-month') {
        this.fnPeriodLastMonth()
      } else if (this.periodMode == 'this-year') {
        this.fnPeriodLastYear()
      }
    },
    fnDelaersTagAdd() {
      this.arrDataQuotesId = this.dealers.map((obj) => obj.id.toString())

      this.getDashbordInformation()

      this.fnPeriod(this.periodMode)
    }
  },
  created() {
    //need this
    this.userObj = authService.getUserFromToken()
    this.fetchUserById(this.userObj.id)
    this.fetchDDealerThisMonthData(this.userObj.id)
    this.fetchDDealerLastMonthData(this.userObj.id)
    this.fetchDDealerLastYearData(this.userObj.id)

    this.currentMonthInText = moment().format('MMMM')
    this.lastMonthInText = moment().subtract(1, 'month').format('MMMM')
    this.currentYearInText = moment().format('YYYY')
  },
  watch: {
    getUserById(val) {
      this.getDealersWhichBelongsToUser = val.dealers
    }
  }
}
</script>

<style>
.iq-card-body {
  flex: unset;
}
</style>
